import * as React from 'react'

import logo from '../../../assets/logo.png'

const LOGO = import.meta.env.VITE_LOGO

export interface LogoPropos extends React.ImgHTMLAttributes<HTMLImageElement> {}

const Logo = React.forwardRef<HTMLInputElement, LogoPropos>(
  (props: LogoPropos) => {
    return (
      <img
        className="h-56 w-auto max-w-xs object-contain"
        src={LOGO || logo}
        alt="logo"
        {...props}
      />
    )
  },
)
Logo.displayName = 'Logo'

export { Logo }
